import { faChevronLeft, faGlobe, faSquareInfo } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button } from "@mui/material"
import { translate } from "app/language/service"
import { NotFoundPage } from "page/components/NotFoundPage"
import { UnexpectedErrorPage } from "page/components/UnexpectedErrorPage"
import { navigate } from "page/tools/navigate"
import React from "react"
import { useParams } from "react-router-dom"
import { ContentBox } from "ui/components/ContentBox"
import { FlexBox } from "ui/components/FlexBox"
import { PageHeader } from "ui/components/main-layout/PageHeader"
import { AdvertiserDomainList } from "./AdvertiserDomainList"
import { AdvertiserForm } from "./AdvertiserForm"

export const AdvertiserPage = (): JSX.Element => {
  const [errorCode, setErrorCode] = React.useState<number | null>(null)
  const { advertiserId } = useParams()
  const id = typeof advertiserId === "string" && advertiserId !== "" ? Number(advertiserId) : undefined
  return (
    <FlexBox vertical fullWidth fullHeight ai="start" jc="start">
      <PageHeader title={translate(typeof id === "number" ? "advertiser.update.title" : "advertiser.add.title")} />
      <FlexBox
        fullWidth
        gap
        jc="start"
        ai="start"
        vertical
        sx={{
          height: "calc(100% - 4rem)",
          p: "1rem",
          overflow: "auto"
        }}>
        {errorCode === 404 ? (
          <NotFoundPage />
        ) : errorCode ? (
          <UnexpectedErrorPage />
        ) : (
          <FlexBox vertical fullWidth>
            <FlexBox fullWidth jc="start" sx={{ mb: "1rem" }}>
              <Button
                startIcon={<FontAwesomeIcon icon={faChevronLeft} />}
                onClick={() => navigate(-1)}
                variant="contained">
                {translate("button.back")}
              </Button>
            </FlexBox>
            <ContentBox
              id="advertiser-info-content-box"
              icon={faSquareInfo}
              title={translate("advertiser.info")}
              vertical>
              <AdvertiserForm advertiserId={id} onInitDataError={newErrorCode => setErrorCode(newErrorCode)} />
            </ContentBox>
            <ContentBox
              id="advertiser-domain-content-box"
              icon={faGlobe}
              title={translate("advertiser.domains")}
              defaultClosed
              vertical>
              <AdvertiserDomainList advertiserId={id} />
            </ContentBox>
          </FlexBox>
        )}
      </FlexBox>
    </FlexBox>
  )
}
